import React from 'react'
import { Portal } from '@chakra-ui/react'

export default (props) => {
  return <Portal {...props} />
}
